// extracted by mini-css-extract-plugin
module.exports = {"quotaArea":"quota_quotaArea__3B8aB"};